
<template>
  <div>
    <tasks-this-week></tasks-this-week>

    <next-tasks></next-tasks>

    <tasks-pending-config></tasks-pending-config>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import NextTasks from './lists/NextTasks.vue'
import TasksPendingConfig from './lists/TasksPendingConfig.vue'
import TasksThisWeek from './lists/TasksThisWeek.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'TaskList',
  //mixins: [ validations ],
  components: {
    NextTasks,
    TasksThisWeek,
    TasksPendingConfig
    //ComponentName: () => import(''),
  },
  data() {
    return {
      
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>